import type { AudienceGender } from 'api/new-analytics/types';

export interface GenderSlices {
  menPercent: number;
  womenPercent: number;
  otherPercent: number;
}

export function mapGenderToSlices(
  gender: AudienceGender[] | undefined,
): GenderSlices {
  if (!gender?.length) {
    return { menPercent: 0, womenPercent: 0, otherPercent: 0 };
  }
  let menPercent = 0;
  let womenPercent = 0;
  let otherPercent = 0;
  gender.forEach((entry) => {
    const code = entry.gender.toUpperCase();
    if (code === 'M') {
      menPercent += entry.percent;
    } else if (code === 'F') {
      womenPercent += entry.percent;
    } else {
      otherPercent += entry.percent;
    }
  });
  return { menPercent, womenPercent, otherPercent };
}
